// extracted by mini-css-extract-plugin
module.exports = {"accordion":"UserDataSummary_accordion__iFrxk"};